import { Icon, IconProps } from "@chakra-ui/react";

export const IconGridView = (props: Omit<IconProps, "css" | "children">) => (
    <Icon viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2" />
            <rect x="8.5" y="3.5" width="1" height="17" stroke="currentColor" />
            <rect x="14.5" y="3.5" width="1" height="17" stroke="currentColor" />
            <rect transform="rotate(90 21.5 8.5)" x="21.5" y="8.5" width="1" height="17" stroke="currentColor" />
            <path d="m21.5 14.5v1h-17v-1h17z" stroke="currentColor" />
        </g>
    </Icon>
);
